import { Button, Flex, Modal, ScrollArea } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { observer } from 'mobx-react';
import { t } from 'i18next';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { useLegalDocumentUrl } from '../../../entities/Legal/useLegalDocumentUrl.tsx';

interface TermsModalProps {
    opened: boolean;
    onClose: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = observer(({ opened, onClose }) => {
    const [markdown, setMarkdown] = useState('');
    const documentUrl = useLegalDocumentUrl('TermsOfUse', opened);

    useEffect(() => {
        if (!opened) return;

        const loadMarkdown = async () => {
            try {
                const res = await fetch(documentUrl);
                const text = await res.text();
                setMarkdown(text);
            } catch {
                setMarkdown('⚠️ Failed to load terms.');
            }
        };

        loadMarkdown();
    }, [opened, documentUrl]);

    return (
        <Modal opened={opened} onClose={onClose} title={t('termsAcceptance.modalTitle')} size="xl" centered>
            <ScrollArea h={'75%'}>
                <ReactMarkdown 
                    remarkPlugins={[remarkGfm]} 
                    rehypePlugins={[rehypeRaw]}
                    components={{
                        table: (props) => <table className="markdown-table" {...props} />,
                        th: (props) => <th className="markdown-th" {...props} />,
                        td: (props) => <td className="markdown-td" {...props} />,
                    }}
                >
                    {markdown}
                </ReactMarkdown>
            </ScrollArea>

            <Flex justify={'flex-end'}>
                <Button onClick={onClose}>{t('button.close')}</Button>
            </Flex>
        </Modal>
    );
});

export default TermsModal;

export const capitalizeFirst = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
